import React from 'react';
import { IconVideoOff } from '../../../base/icons/svg';
import BaseIndicator from '../../../base/react/components/web/BaseIndicator';
/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const VideoMutedIndicator = ({ tooltipPosition }) => (React.createElement(BaseIndicator, { icon: IconVideoOff, iconId: 'mic-disabled', iconSize: 16, id: 'audioMuted', tooltipKey: 'videothumbnail.mute', tooltipPosition: tooltipPosition }));
export default VideoMutedIndicator;
